// extracted by mini-css-extract-plugin
export var standaloneTable = "_gl-0";
export var standaloneTableWithBodyFill = "_gl-1";
export var withExtraHeader = "_gl-2";